import { RxCross2 } from "react-icons/rx";
import {
  Button,
  Col,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Row,
} from "reactstrap";

const ViewImage = ({ url, name, imageOpen, handleImageClose }) => {
 
  return (
    <>
      <Modal
        isOpen={imageOpen}
        toggle={handleImageClose}
        size="lg"
        modalClassName="zoom"
      >
        <ModalHeader
          toggle={handleImageClose}
          close={
            <button className="close" onClick={handleImageClose}>
              <RxCross2 />
            </button>
          }
        ></ModalHeader>
        <ModalBody>
          <Row className={`container-xl`}>
            <Col md={`12`}>
              <div className="d-flex justify-content-center align-items-center">
                <img
                  src={url}
                  alt="preview-image"
                  style={{ width: "100%", height: "auto" }}
                />
              </div>
            </Col>
          </Row>
        </ModalBody>
        <ModalFooter>
          <Button color="danger" size="md" onClick={handleImageClose}>
            Close
          </Button>
        </ModalFooter>
      </Modal>
    </>
  );
};

export default ViewImage;
